import React, { useState } from "react";
import PropTypes from "prop-types";
import ExperienceDisplay from "./experienceDisplay";
import EditExperience from "./editExperience";
import useExperience from "./useExperience";
import { scrollIntoView } from "utils/helper";

function VendorExperience({ isShowEditIcon = true }) {
  const [isEditMode, setIsEditMode] = useState(false);
  const { onSaveExperience, isLoading } = useExperience();

  const handleEditClick = () => {
    setIsEditMode(true);
  };

  const handleCancel = () => {
    setIsEditMode(false);
    scrollIntoView("experienceSection");
  };

  const onSave = async (values) => {
    await onSaveExperience(values);
    setIsEditMode(false);
  };

  if (isEditMode) {
    return (
      <EditExperience
        onCancel={handleCancel}
        onSave={onSave}
        isLoading={isLoading}
      />
    );
  }

  return (
    <ExperienceDisplay
      onEditClick={handleEditClick}
      isShowEditIcon={isShowEditIcon}
    />
  );
}

VendorExperience.propTypes = {
  isShowEditIcon: PropTypes.bool,
};

export default VendorExperience;
